// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentTitleFragmentDoc } from './content/ContentTitle.fragment.generated';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
export const ComponentShopWithConfidenceFragmentDoc = gql`
    fragment componentShopWithConfidence on ComponentShopWithConfidence {
  shopWithConfidenceTitle: title {
    ...componentTitle
  }
  components {
    __typename
    content {
      ...contentComponentItem
    }
  }
}
    ${ComponentTitleFragmentDoc}
${ContentComponentItemFragmentDoc}`;
export const ShopWithConfidenceProductFragmentDoc = gql`
    fragment shopWithConfidenceProduct on CatalogueProduct {
  isReturnable
  ... on CatalogueEngagementRing {
    isResizeable
    signatureStone {
      __typename
    }
  }
  ... on CatalogueWeddingRing {
    isResizeable
    signatureStone {
      __typename
    }
  }
  ... on CatalogueJewelleryRing {
    isResizeable
    signatureStone {
      __typename
    }
  }
  ... on CatalogueJewelleryBracelet {
    signatureStone {
      __typename
    }
  }
  ... on CatalogueJewelleryEarrings {
    signatureStone {
      __typename
    }
  }
  ... on CatalogueJewelleryNecklace {
    signatureStone {
      __typename
    }
  }
  ... on CatalogueReadyToGoRing {
    signatureStone {
      __typename
    }
  }
}
    `;